// Refill only after a deferred URL sync clears the field and then restores the
// string we already emitted. A locale change rewrites keywords in place, and
// in-progress text can differ from that string without being empty.
export const shouldRehydrateSearch = ({ value, lastEmitted, shown }) =>
  value !== lastEmitted || (shown === '' && value !== '');
